import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

import { I18nService } from '@recruitee/i18n';

import { TaggerComponent, TaggerTag } from '../tagger/tagger.component';

@Component({
  selector: 'rt-emails-input',
  template: `
    <rt-tagger
      [control]="control"
      [markInvalid]="true"
      [tagValidator]="tagValidator"
      [preserveWhiteSpaces]="true"
      [applyStyleOnFocus]="true"
      [placeholder]="tags.length === 0 ? placeholder : ''"
      [tags]="tags"
      [disabled]="disabled"
      (tagsChange)="tagsChange.emit($event)"
      (deleteLastTag)="tagsChange.emit(tags.slice(0, -1))"
      (firstEmail)="firstEmailChange.emit($event)"
      variant="email"
    ></rt-tagger>
  `,
  styleUrls: ['./emails-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TaggerComponent],
})
export class EmailsInputComponent {
  public control: UntypedFormControl = new UntypedFormControl([]);

  @Input() public placeholder: string = this.i18n.translate('rtu.common.email_tagger_placeholder');
  @Input() public tags: TaggerTag[] = [];
  @Input() public tagValidator: (control: AbstractControl) => string | null;
  @Input() public disabled: boolean = false;
  @Output() public tagsChange: EventEmitter<TaggerTag[]> = new EventEmitter();
  @Output() public firstEmailChange: EventEmitter<string | null> = new EventEmitter();

  constructor(private i18n: I18nService) {}
}
